import React from "react";
import { ButtonWrapper, Flex, ButtonWrapperError, ErrorMsgContainer, ButtonWrapperNew, GhostButtonComponentTiff, NextButtonWrapper } from "./styles";
import {
  PrimaryButtonComponent,
  GhostButtonComponent,
  DataHeading,
  ErrorMsg
} from "../../../../../CommonComponents/commonStyles";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
const Buttons = props => {
  switch (props.type) {
    case 1:
      return (
        <NextButtonWrapper
         messageShown={props.enableNextButton}>
          {props.enableNextButton && <DataHeading className="mb-xs-20">You have entered more than 90% of all pool balance</DataHeading>}
            <GeneralButton data-test="btnNext"
                text="NEXT" 
                mobWidth="100%"
                id="btnNext" 
                opacity={props.opacity}
                width={props.width}
                onClick={props.onClickNext}
                disabled={props.disabled}
            />
        </NextButtonWrapper>
      );

    case 2:
      return (
        <ButtonWrapperError>
          <ErrorMsgContainer>
              {props.step2Error ? <ErrorMsg>Total allocations must equal 100%</ErrorMsg> : ''}
          </ErrorMsgContainer>
          <ButtonWrapperNew>
            <GeneralButton
                text="NEXT" 
                id="btnNext" 
                mobWidth="100%"
                opacity={props.opacity}
                width={props.width}
                onClick={props.onClickNext}
                disabled={props.disabled}
            />
            <Flex>
              <GeneralButton 
                  type="functional" 
                  inverted={true} 
                  text="BACK" 
                  mobWidth="50%"
                  onClick={props.onClickBack}
                  width={props.width}
                  id="btnBack"
              />
              <GeneralButton 
                  type="functional" 
                  inverted={true} 
                  text="EXIT" 
                  mobWidth="50%"
                  onClick={props.onClickExit}
                  width={props.width}
                  styling="ml-16"
                  id="btnExit"
              />
            </Flex>
          </ButtonWrapperNew>
        </ButtonWrapperError>
      );
    case 3: {
      return (
        <ButtonWrapper>
          <GeneralButton
              text="SUBMIT" 
              id="btnSubmit" 
              mobWidth="100%"
              opacity={props.opacity}
              width={props.width}
              onClick={props.onClickSubmit}
              disabled={props.disabled}
              id="btnSubmit"
          />
          <Flex>
              <GeneralButton 
                  type="functional" 
                  inverted={true} 
                  text="BACK" 
                  mobWidth="50%"
                  onClick={props.onClickBack}
                  width={props.width}
                  id="btnBack"
              />
              <GeneralButton 
                  type="functional" 
                  inverted={true} 
                  text="EXIT" 
                  mobWidth="50%"
                  onClick={props.onClickExit}
                  width={props.width}
                  styling="ml-16"
                  id="btnExit"
              />
          </Flex>
        </ButtonWrapper>
      );
    }
    case 4: {
      return (
        <ButtonWrapperError>
          <ErrorMsgContainer>
              {props.step2Error ? <ErrorMsg>Total allocations must equal 100%</ErrorMsg> : ''}
          </ErrorMsgContainer>
          <ButtonWrapperNew>
              <GeneralButton
                text="UPDATE" 
                id="btnUpdate" 
                styling="mt-md-20"
                opacity={props.opacity}
                width={props.width}
                onClick={props.onClickUpdate}
                disabled={props.disabled}
              />
              <GeneralButton 
                  type="functional" 
                  inverted={true} 
                  text="CANCEL" 
                  width={props.width}
                  onClick={props.onClickCancel}
                  id="btnCancel"
              />
          </ButtonWrapperNew>
        </ButtonWrapperError>
      );
    }
  }
};

export default Buttons;
